<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="600"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer ref="observer">
      <v-form>
        <v-card
          v-if="manifestId"
          flat
        >
          <v-toolbar flat>
            <v-toolbar-title>排出事業者の編集</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <!-- 引渡担当者 -->
            <v-row dense>
              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`deliver_staff`"
                  :class="forms.manifest_type === 'dxe_form' ? 'requiredMark' : '' "
                  :rules="{ required: forms.manifest_type === 'dxe_form', max: 12 }"
                  name="引渡担当者"
                >
                  <v-combobox
                    v-model="forms.deliver_staff"
                    :error-messages="errors"
                    :items="deliverers"
                    :return-object="false"
                    dense
                    label="引渡担当者"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>引渡担当者</span>
                      <span class="ml-1">
                        ({{ forms.deliver_staff?.length || 0 }} / 12)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-combobox>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /引渡担当者 -->
            <!-- 登録担当者 -->
            <v-row dense>
              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`register_staff`"
                  name="登録担当者"
                  rules="max:12"
                >
                  <v-combobox
                    v-model="forms.register_staff"
                    :error-messages="errors"
                    :items="registers"
                    :return-object="false"
                    dense
                    label="登録担当者"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>登録担当者</span>
                      <span class="ml-1">
                        ({{ forms.register_staff?.length || 0 }} / 12)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-combobox>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /登録担当者 -->
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              更新
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
    <send-mail-confirmable-dialog
      :manifest-id="manifestId"
      :enable-dialog="enableMailConfirmableDialog"
      @negativeCallback="negativeCallback"
      @positiveCallback="positiveCallback"
    />
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import SendMailConfirmableDialog from '@/driver/pages/manifest/managements/dialogs/_SendMailConfirmableDialog.vue'

export default {
  name: 'EditEmissionDialog',
  components: {
    SendMailConfirmableDialog,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false
    },
    manifestId: {
      type: Number,
      default: () => null,
    },
    deliverers: {
      type: Array,
      default: () => []
    },
    registers: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      enableMailConfirmableDialog: false,
      forms: {
        manifest_type: null,
        deliver_staff: null,
        register_staff: null,
      },
    }
  },
  computed: {},
  watch: {
    enableDialog (newVal) {
      this.$nextTick(() => this.$refs.observer.reset())
      Object.assign(this.$data.forms, this.$options.data().forms)
      if (newVal) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestManagementEmission', {
      fetchEmission: 'edit',
      updateEmission: 'update',
    }),
    ...mapActions("DriverManifestManagementVerifyEmission", {
      verifyEmission: "update",
    }),
    setVariable () {
      this.fetchEmission({ id: this.manifestId }).then((content) => {
        this.forms = content
      })
    },
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    negativeCallback () {
      this.enableMailConfirmableDialog = false;
    },
    positiveCallback () {
      this.updateManifest()
    },
    registerButtonClickEvent () {
      const $self = this;
      this.$refs.observer.validate().then((result) => {
        if(result) {
          setTimeout($self.sendRegistrationInformation, 500);
        }
      })
    },
    sendRegistrationInformation () {
      let params = this.buildParams();
      this.verifyEmission({ id: this.manifestId, params: params }).then((content) => {
        if (content.changed) {
          this.enableMailConfirmableDialog = true;
        } else {
          this.updateManifest(params);
        }
      })
    },
    updateManifest () {
      let params = this.buildParams()
      this.updateEmission({ id: this.manifestId, params: params }).then(() => {
        this.enableMailConfirmableDialog = false;
        this.$emit('registerCallback')
      })
    },
    buildParams () {
      let params = {
        deliver_staff: this.forms.deliver_staff,
        register_staff: this.forms.register_staff,
      }
      return params;
    }
  }
}
</script>
